<content-state [isLoading]="isLoading">
  <div class="flex flex-col">
    @if (validPaymentMethod) {
      <span class="font-semibold">{{ 'Congratulations' | translate }}</span>
      <span class="mt-1">{{
        'You’ve successfully set up your billing and payment details. You can close this window.' | translate
      }}</span>
    }
    @if (!validPaymentMethod) {
      <span class="font-semibold">{{ 'Error' | translate }}</span>
      <span class="mt-1">{{
        'Something went wrong while setting up your billing and payment details. You can go back and try again.'
          | translate
      }}</span>
    }
  </div>

  <div class="mt-4 flex flex-row-reverse">
    <button sb-button color="primary" (click)="closePressed.emit()" class="ml-2">
      {{ 'Close' | translate }}
    </button>
    @if (!validPaymentMethod) {
      <button sb-button color="secondary" (click)="backPressed.emit()">
        {{ 'Back' | translate }}
      </button>
    }
  </div>
</content-state>
